import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const FormularioNewsletter = ({ empresa }) => {
  return (
    <ContenedorFormularioNewsletter>
      <form
        className="description"
        id="theform"
        name="theform"
        action={`https://my.sendinblue.com/users/subscribeembed/js_id/382wq/id/${
          empresa && empresa.footer_formulario_form_id
        }`} //=> id footer_formulari_form_id
        method="POST"
      >
        <input type="hidden" name="js_id" id="js_id" value="382wq" />
        <input
          type="hidden"
          name={empresa && empresa.footer_formulario_lista}
          id={empresa && empresa.footer_formulario_lista}
          value="4"
        />{" "}
        {/**listid footer_formulario_lista*/}
        <input type="hidden" name="from_url" id="from_url" value="yes" />
        <input type="hidden" name="hdn_email_txt" id="hdn_email_txt" value="" />
        <input type="hidden" name="sib_simple" value="simple" />
        <input
          type="hidden"
          name="sib_forward_url"
          value={`${
            empresa && empresa.sitio_web
          }/index.php?ctrl=index&amp;sucripcion=1`}
          id="sib_forward_url"
        />
        <TextField
          required
          type="text"
          name="NOMBRE"
          id="NOMBRE"
          placeholder="Tu Nombre"
        />
        <TextField
          required
          type="email"
          name="email"
          id="email"
          placeholder="Tu E-mail"
          pattern="[a-zA-Z0-9._\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,4}"
        />
        <Boton
          type="submit"
          data-editfield="subscribe"
          name="submit"
          id="submit"
          onClick={() => {
              try {
                rrApi.setEmail(document.getElementById("email").value);
              }catch(e){}
            }
          }
        >
          Suscribirme a las Ofertas por E-Mail
        </Boton>
        <Aviso>
          Respetamos tu privacidad y no toleramos el SPAM y nunca venderemos,
          rentaremos, o regalaremos tu información (Nombre, E-Mail, Número, Etc)
          a ningún tercero.
        </Aviso>
      </form>
    </ContenedorFormularioNewsletter>
  );
};

const ContenedorFormularioNewsletter = styled.article`
  padding: 10px;
  background-color:${(props) => props.theme.primario};
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
`;
const Boton = styled.button`
  background-color:${(props) => props.theme.primarioHover};
  color: white;
  border: 1px solid ${(props) => props.theme.primarioHover};
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 10px 5px 10px 5px;
`;
const Aviso = styled.div`
  color: white;
  font-size: 11px;
`;
const TextField = styled.input`
 width: 96%;
  padding: 2%;
  border: 0px;
  margin-bottom: 10px;
  font-size: 14px;
`;
FormularioNewsletter.propTypes = {
  empresa: PropTypes.object,
};
export default FormularioNewsletter;
